theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      const getDirectChildByClass = (parent, className) => {
        if (!parent || !parent.children) return null;
        return Array.from(parent.children).find(
          (child) => child.classList && child.classList.contains(className)
        );
      };

      const updateToggleA11yLabel = (toggle, label, isExpanded) => {
        if (!toggle || !label) return;
        toggle.setAttribute(
          "aria-label",
          `${isExpanded ? "Hide" : "Show"} subcategories for ${label}`
        );
      };

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const parent = ul.parentNode;
          const existingToggle = getDirectChildByClass(
            parent,
            "offcanvas__sub_menu_toggle"
          );
          const menuItem = ul.previousElementSibling;
          const subMenuToggle = existingToggle || document.createElement("button");
          if (!existingToggle) {
            subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
            subMenuToggle.setAttribute("aria-expanded", "false");
            parent.appendChild(subMenuToggle);
          }
          if (
            menuItem &&
            (menuItem.classList.contains("offcanvas__menu_item") ||
              menuItem.classList.contains("offcanvas__sub_menu_item"))
          ) {
            menuItem.classList.add("offcanvas__menu_item--expandable");
            menuItem.setAttribute("aria-expanded", "false");
            const label = menuItem.textContent ? menuItem.textContent.trim() : "";
            if (label) {
              updateToggleA11yLabel(subMenuToggle, label, false);
            }
          } else if (!subMenuToggle.getAttribute("aria-label")) {
            subMenuToggle.setAttribute("aria-label", "Show subcategories");
          }
          ul.setAttribute("aria-hidden", "true");
        });


      });
      
      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        body.style.overflowY = "hidden";
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        const getDirectChild = (parent, className) => {
          const children = Array.from(parent.children || []);
          return children.find(
            (child) => child.classList && child.classList.contains(className)
          );
        };

        const setExpandedState = (parent, isExpanded) => {
          const toggle = getDirectChild(parent, "offcanvas__sub_menu_toggle");
          const row =
            getDirectChild(parent, "offcanvas__menu_item") ||
            getDirectChild(parent, "offcanvas__sub_menu_item");
          const submenu = getDirectChild(parent, "offcanvas__sub_menu");
          if (toggle) {
            toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
            toggle.classList.toggle("active", isExpanded);
          }
          if (row) {
            row.setAttribute("aria-expanded", isExpanded ? "true" : "false");
            const label = row.textContent ? row.textContent.trim() : "";
            updateToggleA11yLabel(toggle, label, isExpanded);
          }
          if (submenu) {
            submenu.setAttribute("aria-hidden", isExpanded ? "false" : "true");
          }
          parent.classList.toggle("active", isExpanded);
        };

        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              setExpandedState(parent, false);
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                setExpandedState(subMenu.parentElement, false);
                slideUp(subMenu, 320);
              });
            } else {
              setExpandedState(parent, true);
              slideDown(this.previousElementSibling, 320);
              getSiblings(parent).forEach(function (item) {
                setExpandedState(item, false);
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  setExpandedState(subMenu.parentElement, false);
                  slideUp(subMenu, 320);
                });
              });
            }
          });
        });

        offcanvasMenuitem
        .querySelectorAll(".offcanvas__menu_item--expandable")
        .forEach(function (row) {
          row.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.parentElement;
            const toggle = getDirectChild(parent, "offcanvas__sub_menu_toggle");
            if (toggle) toggle.click();
          });
        });
      })
      

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
